// client/src/services/paymentBylawService.js
import api from './api';

const paymentBylawService = {
  getPaymentBylaws: async () => {
    const response = await api.get('/payment-bylaws');
    return response.data;
  },
  
  getPaymentBylaw: async (id) => {
    const response = await api.get(`/payment-bylaws/${id}`);
    return response.data;
  },
  
  getActiveBylaws: async () => {
    const response = await api.get('/payment-bylaws/active');
    return response.data;
  },
  
  createPaymentBylaw: async (bylawData) => {
    let copypath = '/payment-bylaws';
    if (bylawData.source_bylaw_id)
         copypath = '/payment-bylaws/copy'

    const response = await api.post(copypath, bylawData);
    return response.data;
  },
  
  approvePaymentBylaw: async (id) => {
    const response = await api.put(`/payment-bylaws/${id}/approve`);
    return response.data;
  },


  reopenForEdit: async (id) => {
    const response = await api.put(`/payment-bylaws/${id}/reopen`);
    return response.data;
  },
  

  deletePaymentBylaw: async (id) => {
    const response = await api.delete(`/payment-bylaws/${id}`);
    return response.data;
  },

};

export default paymentBylawService;